<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :headerScreenJson="getHeaderScreenJson"
    :setLoading="setLoading"
    :localDataGrid="true"
    :backButtonRoute="backButtonRoute"
    ref="batch-payment"
    :data-model="getDataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import CheckBox from "devextreme/ui/check_box";
import { FeatureStorage } from "../../_services/storage";
import { mapGetters } from "vuex";
import { BatchPaymentService } from "../../_services/api/suppliers/batch-payment-service";
export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      loaded: false,
      setLoading: false,
      reload: false,
      validationSummary: [],
      serverError: {},
      batchPaymentData: [],
      localDataList: [],
      isSaveAsDraftProcessed: false,
      dataModel: {
        Status: undefined,
        DueDate: undefined,
        SupplierType: undefined,
        SupplierCode: undefined,
        Terms: undefined,
        Branch: undefined,
        Division: undefined,
        BankAccount: undefined,
        PaymentDate: undefined,
        SaveAs: undefined,
        footerAllocatedAmount: 0,
        footerCheckInclude: 0,
      },
      goBackRoute: "/supplier/batch-payment-list",
      RunId: undefined,
      MinDate: undefined,
      MaxDate: undefined,
      AccountingPeriod: undefined,
    };
  },

  async created() {
    this.initialized();
    this.dataModel.Status = this.baseView.query.Status;
  },
  async mounted() {},

  computed: {
    ...mapGetters({ dataViewType: "dataContext/getDataViewType" }),
    ...mapGetters({ gridExpand: "ui/getGridExpand" }),
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    backButtonRoute() {
      if (this.baseView.query && this.baseView.query.from) {
        return this.baseView.query.from;
      } else return this.goBackRoute;
    },
    getDataModel() {
      return this.dataModel;
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          headerToolbar: {
            screenName: "Batch Payment",
            pdf: !this.isCreateMode(),
            // audit: !this.isCreateMode(),
            audit: false,
            status: !this.isCreateMode(),
            notes: false,
            save:
              this.baseView.query.Status == "Open" ||
              this.baseView.mode != "review",
            editURL: `/supplier-batch-payment`,

            saveOptions: {
              items: this.getSaveOptions(),
              keyExpr: "id",
              displayExpr: "text",
              dropDownOptions: {
                width: "150px",
              },
              saveKey: "SaveAs",
            },
            elipsis: {
              menuItems: [
                {
                  menuText: "Cancel",
                  disabled: false,
                },
              ],
              visible: this.isReviewMode() && this.baseView.query.Status == "A",

              clickAction: (e) => {
                if (e.itemData.menuText == "Cancel") {
                  this.cancelPayment();
                }
              },
            },
            saveCallback: this.saveBatchPayment,
          },
          formItems: this.getFields(),
          title: {
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: undefined,
                text: this.getScreenTitle(),
              },
              secondary: {
                dataField: undefined,
                text: undefined,
              },
            },
            secondary: {
              dataField: undefined,
              text: undefined,
            },
          },
        },
      };
    },
    getScreenJson() {
      var screenJson = {
        title: "Batch Payment",
        endpoint: {
          primary: undefined,
        },
        gridData: {
          gridOptions: {
            dataSource: {
              allowGrouping: false,
              items: this.localDataList,
              localDataList: true,
            },
            noDataMessage: {
              review: {
                addNew: {
                  class: "add-new",
                  title: "Create a Batch Payment",
                  message:
                    "Get started by adding parameters and generating your requirements",
                },
              },
            },
          },
          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: true,
            review: false,
          },
          columns: [
            {
              screenField: "CheckInclude",
              allowEditing: false,
              defaultValue: false,
              valueChangeCallBack: this.checkBoxValueChange,
              allowHiding: false,
              showInColumnChooser: false,
              fixed: true,
              fixedPosition: "left",
              label: "",
              allowSearch: false,
              makeReadOnly: () => {
                return !this.isCreateMode();
              },
              visible: !this.isReviewMode(),
              cssClass: "column-cx-check-box",
              width: 50,
            },
            {
              screenField: "Date",
              gridDataField: "InvDate",
              filterDataField: "InvDate",
              showInColumnChooser: true,
              filterIndex: 0,
              allowSorting: true,
              allowSearch: false,
            },
            {
              screenField: "Supplier",
              gridDataField: "SupplierCode",
              filterDataField: "SupplierCode",
              showInColumnChooser: false,
              filterIndex: 1,
              groupIndex: 0,
              allowSorting: true,
              allowSearch: true,
              groupCellTemplate: "group-cell-template",
              calculateGroupCellDisplayValue: (data) => {
                let supplier = this.localDataList.find(
                  (x) => x.SupplierCode == data.data.key
                );
                return `Supplier : ${supplier.SupplierName} (${data.data.key})`;
              },
            },
            {
              screenField: "SupplierTransactionNumber",
              label: "Inv Number",
              gridDataField: "InvNumber",
              filterDataField: "InvNumber",
              showInColumnChooser: true,
              allowSorting: true,
              allowSearch: true,
              // width: "auto",
            },
            {
              screenField: "Amount",
              dataField: "Amount",
              gridDataField: "Amount",
              filterDataField: "Amount",
              label: "Amount",
              showInColumnChooser: true,
              allowSorting: true,
              allowSearch: false,
            },
            {
              screenField: "Balance",
              dataField: "Balance",
              label: "Outstanding",
              gridDataField: "Balance",
              filterDataField: "Balance",
              showInColumnChooser: true,
              allowSorting: true,
              allowSearch: false,
              allowUpdate: true,
              makeReadOnly: false,
            },
            {
              screenField: "Discount",
              dataField: "Discount",
              label: "Discount",
              gridDataField: "Discount",
              filterDataField: "Discount",
              type: "EditableDecimal",
              showInColumnChooser: true,
              allowSorting: true,
              allowSearch: false,
              allowEditing: true,
              showEditorAlways: true,
              makeReadOnly: ({ data }) => {
                return !data.CheckInclude;
              },
            },
            {
              screenField: "AllocatedAmount",
              gridDataField: "AllocatedAmount",
              dataField: "AllocatedAmount",
              type: "EditableDecimal",
              showInColumnChooser: true,
              subTotal: "SUM",
              allowSorting: true,
              allowSearch: false,
              allowEditing: true,
              showEditorAlways: true,
              makeReadOnly: ({ data }) => {
                return !data.CheckInclude;
              },
            },
          ],
          valueChangedEventListners: [
            {
              dataField: "AllocatedAmount",
              listner: ({ value }, { data: lineData }) => {
                lineData.AllocatedAmount = value;
                // lineData.Balance = lineData.Amount - (lineData.AllocatedAmount + lineData.Discount);
                this.$refs["batch-payment"].$refs[
                  "transactionGrid"
                ].gridRepaint();
                this.mergeWithReviewView(
                  lineData.AllocatedAmount == 0 ? false : true,
                  lineData
                );
              },
            },
            {
              dataField: "Discount",
              listner: ({ value }, { data: lineData }) => {
                lineData.Discount = value;
                lineData.Discount > 0 ? (lineData.DiscountOk = "Y") : "N";
                // lineData.Balance = lineData.Amount - (lineData.AllocatedAmount + lineData.Discount);
                lineData.AllocatedAmount = lineData.Balance - value;

                this.mergeWithReviewView(
                  lineData.Discount == 0 ? false : true,
                  lineData
                );
                this.$refs["batch-payment"].$refs[
                  "transactionGrid"
                ].gridRepaint();
              },
            },
          ],
        },
        footerData: {
          footerItems: [
            {
              screenField: "AllocatedAmount",
              location: "right",
              value: 0,
              label: "Total Allocated Amount",
              customCalc: (headerData, gridItems) => {
                return this.getTotalAllocatedAmount(headerData, gridItems);
              },
              format: "Decimal-16-2C",
            },
            {
              screenField: "AllocatedAmount",
              location: "left",
              value: 0,
              label: "Number of invoices selected",
              customCalc: (headerData, gridItems) => {
                return this.getCountSelectedInvoices(headerData, gridItems);
              },
              format: "Decimal-16-0",
            },
          ],
        },
      };
      return screenJson;
    },
  },
  methods: {
    async initialized() {
      this.setLoading = true;
      if (this.isCreateMode() || this.isEditMode()) {
        const { data: apFactorDetail } =
          await BatchPaymentService.getAPFactor();
        let activeAccountingPeriod =
          apFactorDetail.value[0].AccountingPeriodCode;
        const { data: activeAccountingPeriodDetail } =
          await BatchPaymentService.getCurrentAccountingPeriod(
            activeAccountingPeriod
          );
        this.AccountingPeriod = activeAccountingPeriod;
        this.ActiveMonth = activeAccountingPeriodDetail.value[0].Month;
        this.ActiveYear = activeAccountingPeriodDetail.value[0].Year;
        this.MinDate = activeAccountingPeriodDetail.value[0].DateStart;
        let { data: dateEndDetail } =
          await BatchPaymentService.getCurrentAccountingPeriodEndDate();

        this.MaxDate = dateEndDetail.value[0].DateEnd;
      }
      if (this.isEditMode() || this.isReviewMode()) {
        const batchPaymentDetail = await BatchPaymentService.getCustomData(
          "api/BatchPaymentDetails",
          this.baseView.id
        );
        this.localDataList = this.batchPaymentDetailPostProcess(
          batchPaymentDetail.data.value
        );
      }
      this.loaded = true;
      this.setLoading = false;
    },
    cancelPayment() {
      this.setLoading = true;
      let payload = {
        RunId: this.baseView.id,
      };
      BatchPaymentService.cancel(payload)
        .then((res) => {
          this.setLoading = false;
          if (res) {
            this.$notify(
              `Batch Payment for ${res.data.RunId} Successfully Cancelled`,
              "success"
            );
            this.$router.push({ path: "/supplier/batch-payment-list" });
          }
        })
        .catch((err) => {
          if (err) {
            this.setLoading = false;
            this.$alert("Batch Payment Cancellation Failed", "Error");
          }
        });
    },
    isReviewMode() {
      return this.baseView.mode == "review";
    },
    isCreateMode() {
      return this.baseView.mode == "create";
    },
    isEditMode() {
      return this.baseView.mode == "edit";
    },
    getScreenTitle() {
      if (this.isReviewMode()) {
        return "Batch Payment Review";
      }
      if (this.isCreateMode()) {
        return "Batch Payment Create";
      }
      if (this.isEditMode()) {
        return "Batch Payment Edit";
      }
    },
    getSaveOptions() {
      var columns;
      var hasCommitAccess = FeatureStorage.checkPermission(
        "BatchPaymentCommit",
        "create"
      );

      var hasSaveAccess = FeatureStorage.checkPermission(
        "BatchPaymentSave",
        "create"
      );

      if (this.isCreateMode()) {
        columns = this.getCreateModeSaveOptions();
      } else if (this.isEditMode()) {
        columns = this.getEditModeSaveOptions();
      } else {
        columns = this.getReviewModeSaveOptions();
      }
      if (!hasCommitAccess) {
        columns = columns.filter((column) => column.text !== "Commit");
      }
      if (!hasSaveAccess) {
        columns = columns.filter((column) => column.text !== "Save as Draft");
      }

      return columns;
    },
    getCreateModeSaveOptions() {
      return [
        { text: "Commit", id: "C" },
        { text: "Save as Draft", id: "D" },
      ];
    },
    getEditModeSaveOptions() {
      return [{ text: "Commit", id: "C" }];
    },
    getReviewModeSaveOptions() {
      return [{ text: "Cancel", id: "X" }];
    },
    getFields() {
      if (this.isCreateMode()) {
        return this.getCreateModeFields();
      }
      if (this.isEditMode()) {
        return this.getEditModeFields();
      }
      return this.getReviewModeFields();
    },
    getReviewModeFields() {
      return [];
    },
    getEditModeFields() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "Branch",
                  dataField: "Branch",
                  label: {
                    text: "Branch",
                  },
                  required: true,
                },
                {
                  screenField: "Division",
                  dataField: "Division",
                  label: {
                    text: "Division",
                  },
                  required: true,
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "BankAccount",
                  dataField: "BankAccount",
                  label: {
                    text: "Bank Account",
                  },
                  required: true,
                },
                {
                  screenField: "Date",
                  dataField: "PaymentDate",
                  label: {
                    text: "Payment Date",
                  },
                  editorOptions: {
                    min: this.MinDate,
                    max: this.MaxDate,
                    allowUpdate: true,
                  },
                  required: true,
                },
              ],
            },
          ],
        },
      ];
    },
    getCreateModeFields() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "DueDate",
                  dataField: "DueDate",
                  label: {
                    text: "Due Date",
                  },
                  required: true,
                },
                {
                  screenField: "SupplierType",
                  dataField: "SupplierType",
                  label: {
                    text: "Supplier Type",
                  },
                  editorOptions: {
                    showClearButton: true,
                  },
                  required: false,
                },
                {
                  screenField: "ApremitCreateSuppliers",
                  dataField: "SupplierCode",
                  label: {
                    text: "Supplier",
                  },
                  editorOptions: {
                    showClearButton: true,
                  },
                  required: false,
                },
                {
                  screenField: "Terms",
                  dataField: "Terms",
                  label: {
                    text: "Terms",
                  },
                  required: false,
                },
                {
                  dataField: "Generate",
                  label: {
                    text: " ",
                    visible: false,
                  },
                  editorType: "dxButton",
                  editorOptions: {
                    validationGroup: "gc-header-form",
                    onClick: async (e) => {
                      this.onGenerateClick(e);
                    },
                    text: "Generate",
                    type: "default",
                    rtlEnabled: false,
                    disabled: true,
                    allowUpdate: this.dataModel.DueDate !== undefined,
                  },
                },
              ],
            },
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  screenField: "Branch",
                  dataField: "Branch",
                  label: {
                    text: "Branch",
                  },
                  required: true,
                },
                {
                  screenField: "Division",
                  dataField: "Division",
                  label: {
                    text: "Division",
                  },
                  required: true,
                },
                {
                  screenField: "BankAccount",
                  dataField: "BankAccount",
                  label: {
                    text: "Bank Account",
                  },
                  required: true,
                },
                {
                  screenField: "Date",
                  dataField: "PaymentDate",
                  label: {
                    text: "Payment Date",
                  },
                  editorOptions: {
                    min: this.MinDate,
                    max: this.MaxDate,
                    allowUpdate: true,
                  },
                  required: true,
                },
              ],
            },
          ],
        },
      ];
    },
    batchPaymentDetailPostProcess(data) {
      data.forEach((element) => {
        element.CheckInclude = element.LineOk === "Y";
      });
      if (!this.isReviewMode()) {
        setTimeout(() => {
          this.updateHeaderCheckBox(data);
        }, 500);
      }
      return data;
    },
    isValidFilter(key) {
      let result =
        key == "DueDate" ||
        key == "SupplierType" ||
        key == "Supplier" ||
        key == "Terms";
      return result;
    },
    isHeaderField(type) {
      return type === "header";
    },
    async updateHeaderCheckBox(gridItems) {
      var refHeadInstance =
        this.$refs["batch-payment"].$refs["transactionGrid"].$refs[
          "cx-CheckInclude"
        ].getSeletcAllRef().instance;
      var checkBoxHeader = refHeadInstance.element();
      var getInstanceHeader = CheckBox.getInstance(checkBoxHeader);

      let count = 0;
      gridItems.forEach((element) => {
        if (element.CheckInclude) count = count + 1;
      });
      setTimeout(() => {
        if (count > 0 && count != gridItems.length) {
          getInstanceHeader.option("value", undefined);
        } else if (count == 0) {
          getInstanceHeader.option("value", false);
        } else if (count == gridItems.length) {
          getInstanceHeader.option("value", true);
        }
        setTimeout(() => {
          this.$refs["batch-payment"].$refs["transactionGrid"].reSizeGrid();
        }, 200);
      }, 100);
    },
    getTotalAllocatedAmount(headerData) {
      var total = 0;
      this.localDataList.forEach((element) => {
        if (element.CheckInclude) {
          total = total + element.AllocatedAmount;
        }
      });
      headerData.footerAllocatedAmount = total;
      return total;
    },
    getCountSelectedInvoices(headerData) {
      var checkIncludeCount = 0;
      this.localDataList.forEach((element) => {
        if (element.CheckInclude) {
          checkIncludeCount++;
        }
      });
      headerData.footerCheckInclude = checkIncludeCount;
      return checkIncludeCount;
    },
    async checkBoxValueChange(fieldData, recordData) {
      if (!fieldData.event) {
        return;
      }
      if (recordData.rowType == "header") {
        {
          this.localDataList.forEach((el) => {
            el.CheckInclude = fieldData.value;
            el.Discount = 0;
            el.AllocatedAmount = 0;
            this.mergeWithReviewView(fieldData.value, el);
          });
          this.$refs["batch-payment"].$refs["transactionGrid"].updateOptions(
            "dataSource",
            this.localDataList
          );
        }
      } else {
        recordData.data.CheckInclude = fieldData.value;
        if (!fieldData.value) {
          recordData.data.Discount = 0;
          recordData.data.AllocatedAmount = 0;
        } else {
          recordData.data.AllocatedAmount = recordData.data.Balance;
        }
        this.localDataList[
          this.localDataList.indexOf(recordData.data)
        ].CheckInclude = fieldData.value;
        this.mergeWithReviewView(fieldData.value, recordData.data);
        this.$refs["batch-payment"].$refs["transactionGrid"].updateOptions(
          "dataSource",
          this.localDataList
        );
        this.$refs["batch-payment"].$refs["transactionGrid"].gridRepaint();

        this.updateHeaderCheckBox(this.localDataList);
      }
    },
    async onGenerateClick() {
      if (this.localDataList.length > 0) {
        let confirmGenerateClick = await this.$confirm(
          "This will result in losing your unsaved Batch Payment. Are you sure you want to regenerate the data?",
          "Unsaved Changes"
        );
        if (!confirmGenerateClick) return;
        this.localDataList = [];
        this.updateHeaderCheckBox(this.localDataList);
        this.$refs["batch-payment"].$refs["transactionGrid"].updateOptions(
          "dataSource",
          this.localDataList
        );
        this.$refs["batch-payment"].$refs["transactionGrid"].gridRepaint();
      }

      this.setLoading = true;
      let filteData = {
        DueDate: this.dataModel.DueDate.toSaveDate(),
        SupplierCode: this.dataModel.SupplierCode,
        SupplierType: this.dataModel.SupplierType,
        Terms: this.dataModel.Terms ? `${this.dataModel.Terms}` : undefined, // api expects null if empty
        PaymentMethod: "EFT",
        RunId: "000000",
      };

      try {
        let { data } = await BatchPaymentService.getGenerateData(filteData);
        this.RunId = parseInt(data.RunId);
        const batchPaymentDetail = await BatchPaymentService.getCustomData(
          "api/BatchPaymentDetails",
          this.RunId
        );
        this.localDataList = this.batchPaymentDetailPostProcess(
          batchPaymentDetail.data.value
        );
        this.$refs["batch-payment"].$refs["transactionGrid"].updateOptions(
          "dataSource",
          this.localDataList
        );
        this.$refs["batch-payment"].$refs["transactionGrid"].gridRepaint();
        this.setLoading = false;
        this.isSaveAsDraftProcessed = false;
      } catch ({ data }) {
        this.setLoading = false;
        let errorMessage = JSON.parse(data.value)[0].ErrorMessage;
        this.$alert(errorMessage, "Error");
      }
    },
    getBatchPaymentData() {
      return this.batchPaymentData;
    },
    async saveBatchPayment(data) {
      var count = 0;
      var payload = {
        RunId: this.RunId,
        SupplierCode: data.SupplierCode,
        SupplierOk: "Y",
        ActiveMonth: this.ActiveMonth,
        ActiveYear: this.ActiveYear,
        Discount: 0.0,
        BatchPaymentDetails: [],
      };
      this.localDataList.forEach((el) => {
        if (el.CheckInclude) count++;
        payload.BatchPaymentDetails.push({
          LineOk: el.CheckInclude ? "Y" : "N",
          DiscountOk: el.DiscountOk,
          LineNo: el.LineNo,
          InvNo: el.InvNumber,
          InvDate: el.InvDate,
          InvAmount: el.InvAmount,
          Balance: el.Balance,
          DiscountAmount: el.DiscountAmount,
          AllocatedAmount: el.AllocatedAmount,
          SupplierCode: el.SupplierCode,
        });
      });
      if (count === 0) {
        this.$alert(
          "No invoice selected. At least select one invoice to proceed",
          "Error"
        );
        return;
      }
      // save as draft
      if (this.dataModel.SaveAs === "D") {
        if (this.isSaveAsDraftProcessed) {
          this.$alert(
            `The Payment for the ${this.RunId} is already saved`,
            "Error"
          );
          return;
        }
        this.setLoading = true;
        try {
          await BatchPaymentService.saveAsDraft(payload);
          this.setLoading = false;
          this.isSaveAsDraftProcessed = true;
          this.$notify(`Batch payment saved successfully`, "success");
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/supplier/batch-payment-list`,
          });
        } catch ({ data }) {
          this.setLoading = false;
          let errorMessage = JSON.parse(data.value)[0].ErrorMessage;
          this.$alert(errorMessage, "Error");
        }
      } else if (this.dataModel.SaveAs == "C") {
        // save and commit
        const commitPayload = {
          RunId: this.isEditMode() ? parseInt(this.baseView.id) : this.RunId,
          BankCode: data.BankAccount,
          BranchCode: data.Branch,
          DivisionCode: data.Division,
          ChequeDate: data.PaymentDate,
          PaymentMethod: "EFT",
          AccountingPeriod: this.AccountingPeriod,
          CompanyCode: "01",
          ExportCode: "ABA",
        };
        this.setLoading = true;
        try {
          if (!this.isSaveAsDraftProcessed && !this.isEditMode()) {
            await BatchPaymentService.saveAsDraft(payload)
              .then(async (res) => {
                if (res)
                  await BatchPaymentService.Commit(commitPayload)
                    .then((res) => {
                      if (res) this.setLoading = false;
                      this.$notify(
                        `Batch payment Commited successfully`,
                        "success"
                      );
                      this.setIgnoreRouteChangeConfirmation();
                      this.$router.push({
                        path: `/supplier/batch-payment-list`,
                      });
                    })
                    .catch((err) => {
                      this.setLoading = false;
                      this.serverError = {
                        err: err,
                        msg: "Save As Commit Failed",
                        time: new Date().getTime(),
                      };
                    });
              })
              .catch((err) => {
                this.setLoading = false;
                this.serverError = {
                  err: err,
                  msg: "Save As Draft Failed",
                  time: new Date().getTime(),
                };
              });
          }
        } catch ({ data }) {
          this.setLoading = false;
          let errorMessage = JSON.parse(data.value)[0].ErrorMessage;
          this.$alert(errorMessage, "Error");
        }
      }
    },
    mergeWithReviewView(value, item) {
      var index = this.reviewDataSource.findIndex(
        (x) => x.RunId == item.RunId && x.SupplierCode == item.SupplierCode
      );
      if (!value) {
        if (index != -1) {
          this.removeFromReview(index);
        }
      } else {
        if (index != -1) {
          this.removeFromReview(index);
        }
        this.addToReview(item);
      }
    },

    removeFromReview(index) {
      this.reviewDataSource.splice(index, 1);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },

    addToReview(item) {
      item.CheckInclude = true;
      this.reviewDataSource.push(item);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },
  },
  watch: {
    gridExpand() {
      setTimeout(() => {
        if (this.loaded)
          this.$refs["batch-payment"].$refs["transactionGrid"].reSizeGrid();
      }, 150);
    },
  },
};
</script>

<style lang="scss">
.column-cx-check-box {
  text-align: left !important;
}
</style>
